import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { bool, func, node } from "prop-types";
import React from "react";

import theme from "../../../theme";
import { caption, h5 } from "../../Typography";

const Active = css`
  ${h5}
  background-color: ${theme.color("primary")};
  color: ${theme.color("text.light")};
  &:hover {
    color: ${theme.color("text.light")};
  }
`;

const Wrapper = styled.button`
  ${caption};
  padding: 16px;
  border: none;
  background-color: transparent;
  line-height: 1;
  cursor: pointer;
  color: ${theme.color("dark.light")};
  text-align: center;
  margin-left: ${theme.space("xxs")};
  margin-right: ${theme.space("xxs")};
  transition: ${theme.get("transition.default.transition")};

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
  &:hover {
    color: ${theme.color("primary")};
  }
  &:focus {
    outline: none;
  }
  ${({ active }) => active && Active}
`;

const FilterButton = ({ children, onClick, ...props }) => (
  <Wrapper {...props} onClick={onClick}>
    {children}
  </Wrapper>
);

FilterButton.propTypes = {
  children: node.isRequired,
  active: bool,
  onClick: func,
};

FilterButton.defaultProps = {
  active: false,
};

export default FilterButton;
